"use client";

import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/axios";
import { branchesMultiFromSettingsRows } from "@/lib/branches-setting";
import { useAuthStore } from "@/stores/authStore";

/** When false, hide branch pickers and treat shop as single-location (default branch only). */
export function useBranchesEnabled() {
  const token = useAuthStore((s) => s.accessToken);
  const q = useQuery({
    queryKey: ["settings", "all"],
    queryFn: async () => {
      const { data } = await api.get<{ settings: { key: string; value: unknown }[] }>("/api/settings");

      return data.settings ?? [];
    },
    enabled: Boolean(token),
    staleTime: 0,
  });

  const branchesEnabled = useMemo(() => branchesMultiFromSettingsRows(q.data), [q.data]);

  return { branchesEnabled, isLoading: q.isLoading, isFetching: q.isFetching };
}
